var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Season = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 20px;\n  color: ", ";\n"], ["\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 20px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.old.fonts.size.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.old.fonts.weight.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.old.colors.white;
});
export var Episodes = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.old.colors.gray[525];
});
var templateObject_1, templateObject_2;
